module.exports = "<p *ngFor=\"let option of options$ | async\" (click)=\"onSelect(option)\" class=\"entry\">\n  {{option}}\n</p>\n"